export default {
    "User Management": [
        {
            title: "1.0 Creating User Types, Departments and Areas for your Organisation",
            vid_url: "https://youtube.com/embed/QsxqxZnaanM"
        },
        {
            title: "1.1 Registering a new User",
            vid_url: "https://youtube.com/embed/4fsAGcsvR6E"
        },
        {
            title: "1.2 Edit User Details",
            vid_url: "https://youtube.com/embed/XWMoJKAvApg"
        },
        {
            title: "1.3 Editing a Users Access Levels",
            vid_url: "https://youtube.com/embed/JZ2PMMJ3VLM"
        },
        {
            title: "1.4 Assigning Areas and Departments",
            vid_url: "https://youtube.com/embed/KagZ_DNJ4yk"
        },
        {
            title: "1.5 Managing Holiday Requests",
            vid_url: "https://youtube.com/embed/nCSib5qTnp0"
        },
        {
            title: "1.6 Monitoring User Performance",
            vid_url: "https://youtube.com/embed/PxnQ6L6EBlU"
        },
        {
            title: "1.7 Monitoring Workforce Timesheets",
            vid_url: "https://youtube.com/embed/F02B7AZLKDc"
        },
        {
            title: "1.8 Qualification Manager",
            vid_url: "https://youtube.com/embed/176KHd5B4To"
        },
        {
            title: "1.9 Creating Custom Toolbox Talks",
            vid_url: "https://youtube.com/embed/UD02MMPiiIA"
        },
        {
            title: "1.10 Using the Group Messenger Feature",
            vid_url: "https://youtube.com/embed/xhXC8tSxFVo"
        }
    ],
    "Report Management": [
        {
            title: "2.0 Viewing & Printing Reports",
            vid_url: "https://youtube.com/embed/iw5jLpb9snE"
        },
        {
            title: "2.1 Viewing Reports By Location",
            vid_url: "https://youtube.com/embed/9Z1rsFmJfxw"
        },
        {
            title: "2.2 Viewing Reports By Date",
            vid_url: "https://youtube.com/embed/vLGQIHvOvug"
        },
        {
            title: "2.3 Downloading Reports to Excel",
            vid_url: "https://youtube.com/embed/AGLQY-IiX1E"
        }
    ],
    "Equipment Management": [
        {
            title: "3.0 Managing Registered Vehicles",
            vid_url: "https://youtube.com/embed/s7AvtMpMUrE"
        },
        {
            title: "3.1 Registering a New Vehicle",
            vid_url: "https://youtube.com/embed/z0LLDbuWzJQ"
        },
        {
            title: "3.2 Viewing Equipment By Location",
            vid_url: "https://youtube.com/embed/xXOZepknC60"
        },
        {
            title: "3.3 Editing Registered Equipment",
            vid_url: "https://youtube.com/embed/o8LA9INRWm0"
        },
        {
            title:"3.4 Creating a Custom Vehicle Inspection - Equipment Management",
            vid_url: "https://youtube.com/embed/pOx9ZlRiWB0"
        }
    ],
    "Resource Management": [
        {
            title: "4.0 File Manager Overview",
            vid_url: "https://youtube.com/embed/dcd5geG2QOI"
        },
        {
            title: "4.1 Company Policies Overview",
            vid_url: "https://youtube.com/embed/i3d-dlBV3gk"
        },
        {
            title: "4.2 Security Configurations",
            vid_url: "https://youtube.com/embed/s5_o6kzVYhQ"
        },
        {
            title: "4.3 Alerts Section",
            vid_url: "https://youtube.com/embed/a2z4MhMURZo"
        },
        {
            title: "4.4 News Broadcasts",
            vid_url: "https://youtube.com/embed/ltd4-IMdcsA"
        },
        {
            title: "4.5 SSWP Configs",
            vid_url: "https://youtube.com/embed/7o8Iimtb5os"
        },
        {
            title: "4.6 Requesting New Features",
            vid_url: "https://youtube.com/embed/uUp202P6uvM"
        }
    ],
    "Jobpack Management": [
        {
            title: "5.0 Creating a New Jobpack",
            vid_url: "https://youtube.com/embed/leORazBZU1o"
        },
        {
            title: "5.1 Editing Jobpacks",
            vid_url: "https://youtube.com/embed/W4yMw9gmpLk"
        },
        {
            title: " 5.2 Editing a Jobpack State",
            vid_url: "https://youtube.com/embed/ctpnfiwpqkk"
        },
        {
            title: "5.3 Viewing Jobpacks by Location",
            vid_url: "https://youtube.com/embed/7ybIjnsGd2E"
        },
        {
            title: "5.4 Utilizing the Jobpack Roster",
            vid_url: "https://youtube.com/embed/v_rOEZHEogg"
        },
        {
            title: "5.5 Adding a File to a Jobpack",
            vid_url: "https://youtube.com/embed/fuF2SS9UCJE"
        }
    ]
};
